// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/layout/Quaternary.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/layout/Quaternary.tsx");
  import.meta.hot.lastModified = "1732036225883.1047";
}
// REMIX HMR END

import { AuthorCard, ContentWrapper, CTA } from "~/components";
import ToC from "./ToC";
import { BlogTeaser } from "../views";
import SocialShare from "../static/SocialShare";
import { ParagraphViewReference } from "../paragraph";
import Heading from "../Heading";
export default function Quaternary({
  node,
  children
}) {
  return <article>
            <ToC node={node} layout="quaternary">
                <ContentWrapper className="bg-white" Item="div" spacing="quaternary">
                    <BlogTeaser item={node} variant="blogToc" />
                </ContentWrapper>
                <div id="toc-content">
                    {children}
                </div>
                <div className="mb-2 lg:mb-4">
                    <AuthorCard picture={node.author?.picture} name={node.author?.fullName} bio={node.author?.bio} jobTitle={node.author?.jobTitle} />
                </div>
                <div className="block lg:hidden">
                    <SocialShare alignment="primary" />
                </div>
                <Heading tag="h2">Related posts</Heading>
                <ContentWrapper className="bg-white" spacing="quaternary">
                    <ParagraphViewReference variant="secondary" display={node.relatedBlogs.display} items={node.relatedBlogs.results} />
                </ContentWrapper>
                {node.cta && <div className="block lg:hidden">
                        <ContentWrapper className="bg-neutral-100 pt-14" spacing="quaternary">
                            <CTA {...node.cta} />
                        </ContentWrapper>
                    </div>}
            </ToC>
        </article>;
}
_c = Quaternary;
var _c;
$RefreshReg$(_c, "Quaternary");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;